import { DigitalObject } from '../../rendering/binary/DigitalObject.js';
import { DigitalSign } from '../city/DigitalSign.js';
import { pushBoxCollider } from './interiorShell.js';

/**
 * @param {import('./interiorShell.js').InteriorBuildContext} ctx
 */
export function addPropBox(ctx, {
  material,
  size,
  position,
  shape = 'box',
  cellsPerMeter = 6,
  seedOffset = 0,
  name = 'Prop',
  collider = true,
}) {
  const obj = new DigitalObject({
    material,
    shape,
    size,
    position,
    cellsPerMeter,
    seed: ctx.seed + seedOffset,
    cellIdBase: ctx.cellIdBase,
    name,
  });
  ctx.cellIdBase += obj.cellsUsed;
  ctx.group.add(obj.group);
  if (collider) {
    const [sx, sy, sz] = size;
    const [x, y, z] = position;
    pushBoxCollider(ctx, x, y, z, sx, sy, sz);
  }
  return obj;
}

/**
 * @param {import('./interiorShell.js').InteriorBuildContext} ctx
 */
export function addPropPillar(ctx, {
  material,
  size,
  position,
  cellsPerMeter = 7,
  seedOffset = 0,
  name = 'Pillar',
  collider = true,
}) {
  const obj = new DigitalObject({
    material,
    shape: 'pillar',
    size,
    position,
    cellsPerMeter,
    seed: ctx.seed + seedOffset,
    cellIdBase: ctx.cellIdBase,
    name,
  });
  ctx.cellIdBase += obj.cellsUsed;
  ctx.group.add(obj.group);
  if (collider) {
    const [sx, sy, sz] = size;
    const [x, y, z] = position;
    pushBoxCollider(ctx, x, y, z, sx, sy, sz);
  }
  return obj;
}

/**
 * @param {import('./interiorShell.js').InteriorBuildContext} ctx
 */
export function addWallProp(ctx, {
  material,
  size,
  position,
  seedOffset = 0,
  name = 'Partition',
}) {
  const obj = new DigitalObject({
    material,
    shape: 'wall',
    size,
    position,
    cellsPerMeter: 6,
    seed: ctx.seed + seedOffset,
    cellIdBase: ctx.cellIdBase,
    name,
  });
  ctx.cellIdBase += obj.cellsUsed;
  ctx.group.add(obj.group);
  const [sx, sy, sz] = size;
  const [x, y, z] = position;
  pushBoxCollider(ctx, x, y, z, sx, sy, sz);
  return obj;
}

/**
 * @param {import('./interiorShell.js').InteriorBuildContext} ctx
 */
export function addSign(ctx, {
  x,
  y,
  z,
  rotY = 0,
  width = 2.2,
  height = 0.6,
  phrases,
  neon = true,
  seedOffset = 0,
}) {
  const sign = new DigitalSign({
    width,
    height,
    seed: ctx.seed + seedOffset,
    neon,
    phrases,
  });
  sign.mesh.position.set(x, y, z);
  sign.mesh.rotation.y = rotY;
  ctx.group.add(sign.mesh);
  ctx.signs.push(sign);
  return sign;
}
